import Tooltip from "@mui/material/Tooltip";
import { InfoIcon } from "styles/formStyleComponents";

const InfoIconWithTooltip = ({ info }) => {
  if (!info) return null;
  
  return (
    <Tooltip title={info} placement="top">
      <InfoIcon />
    </Tooltip>
  );
};

export default InfoIconWithTooltip;

